// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3_4QS","label":"Category_label__OS5SO","content":"Category_content__13pbt","header":"Category_header__26hT7","location":"Category_location__2ZaNU"};